import React from "react";
import { Link } from "react-router-dom";
import { BrickWall, Warehouse, PlugZap, Zap } from "lucide-react";

const FACTORS = [
  { icon: BrickWall, t: "Wall type", d: "Drywall and studs is standard. Brick, tile, concrete, stone, or plaster-and-lath gets quoted after we see the video." },
  { icon: Warehouse, t: "Access", d: "An attic or crawl space lets us hide wires cleanly. No access, a finished basement, a slab, or a vaulted ceiling means a paintable surface channel or a quoted custom run." },
  { icon: PlugZap, t: "Power", d: "If there is no outlet behind the TV, the in-wall power kit is quoted separately." },
];

export const PriceFactors = () => (
  <section data-testid="price-factors" className="section-pad bg-[#0a1f44] text-white tex-grid-dark tex-glow overflow-hidden">
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8 grid lg:grid-cols-[1fr_2fr] gap-10">
      <div className="lg:sticky lg:top-28 self-start">
        <span className="eyebrow eyebrow-dark">Stated up front</span>
        <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-white">What changes the price</h2>
        <Link to="/tv-mounting-quote" data-testid="price-factors-quote-btn" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#3b9dff] hover:bg-[#2b8ae8] text-white font-bold text-sm transition-colors shadow-[0_10px_24px_-8px_rgba(59,157,255,0.7)]">
          <Zap className="w-4 h-4" /> Instant Quote
        </Link>
      </div>
      <div className="grid gap-4">
        {FACTORS.map((f) => (
          <div key={f.t} className="flex gap-5 rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-md p-6 transition-colors duration-300 hover:border-[#3b9dff]/50 hover:bg-white/[0.07]">
            <span className="w-12 h-12 shrink-0 rounded-xl bg-[#3b9dff]/15 border border-[#3b9dff]/30 flex items-center justify-center"><f.icon className="w-6 h-6 text-[#7dc4ff]" /></span>
            <div>
              <h3 className="text-lg font-bold text-white">{f.t}</h3>
              <p className="mt-1 text-slate-300 leading-relaxed">{f.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
